import "./WarningCard.css";

class WarningCard {
  constructor(warning) {
    this.warning = warning;
  }

  render() {
    const { warning } = this;

    return `
      <div class="warning-card">
        <div class="warning-header">
          <div class="warning-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
              <line x1="12" y1="9" x2="12" y2="13"></line>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
          </div>
          <div class="warning-content">
            <div class="warning-title">
              Longueur d'onde manquante
            </div>
            <div class="warning-details">
              <span class="fiber-info">${warning.idCable} - Fibre ${warning.numFibre}</span>
              <span class="missing-lambda">Manque λ${warning.missingWavelength}nm</span>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  mount(container) {
    container.innerHTML = this.render();
  }
}

export default WarningCard;
